// biome-ignore lint/performance/noBarrelFile: <explanation>
export { join } from './join'
export type { Conflicts } from './join'
